<div class="mapping-page-search-container">
  <mat-form-field class="search-input-container" appearance="outline">
    <mat-label>Search</mat-label>
    <input matInput type="text" placeholder="Search" (input)="onSearchChange($event)">
  </mat-form-field>
</div>
<div class="mapping-page-sort-container">
  <mat-form-field appearance="outline">
    <mat-label>Sort</mat-label>

    <mat-select  (ngModelChange)="onSortTypesDropDownChanged($event)"  [(ngModel)]="selectedFilter">
      <mat-option *ngFor="let sortItem of sortOptions" value={{sortItem}} (change)="setSelectedFilter($event)">{{sortItem}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-icon class="sort-icon" *ngIf="isAsc" (click)="sortUpDownChange()">arrow_upward</mat-icon>
  <mat-icon class="sort-icon" *ngIf="!isAsc" (click)="sortUpDownChange()">arrow_downward</mat-icon>
</div>
<div *ngIf="hasLegends" class="legends-main-container">
  <ng-container [ngTemplateOutlet]="legendTemplate"></ng-container>
</div>
